const menuTrigger = document.querySelector(`.js-menu-trigger`);
const emptyHashes = [...document.querySelectorAll(`[href="#"]`)];

if (menuTrigger) {
  menuTrigger.addEventListener('click', () => {
    document.body.classList.toggle('js-menu-active');
  });
}

if (emptyHashes) {
  for (let index = 0; index < emptyHashes.length; index += 1) {
    emptyHashes[index].addEventListener('click', (e) => {
      e.preventDefault();
    });
  }
}

// Fix for hover menu on mobile
document.addEventListener('DOMContentLoaded', () => {
  const menuItems = document.querySelectorAll(
    '.menu-item-has-children .c-main-nav__link',
  );

  menuItems.forEach((link) => {
    const span = document.createElement('span');
    span.className = link.className;
    span.innerHTML = link.innerHTML;
    link.parentNode.replaceChild(span, link);

    span.parentElement.addEventListener('click', () => {
      const activeItem = document.querySelector('.js-menuItem-active');
      if (activeItem && activeItem !== span.parentElement) {
        activeItem.classList.remove('js-menuItem-active');
      }

      span.parentElement.classList.toggle('js-menuItem-active');
    });
  });
});

// Close menu when clicking outside
document.body.addEventListener('click', (e) => {
  if (
    !e.target.closest('.menu-item-has-children') &&
    document.querySelector('.js-menuItem-active')
  ) {
    // Remove active class from menu item
    document
      .querySelector('.js-menuItem-active')
      .classList.remove('js-menuItem-active');
  }
});
